export default __webpack_public_path__ + "static/media/SG DE upd3.ffc00b03.jpg";